export const FormsConstants = {
  formNames: {
    CUSTOMER_FORM: 'CUSTOMER_FORM',
    DEVICE_FORM: 'DEVICE_FORM',
    ISSUE_FORM: 'ISSUE_FORM',
  },
  formActions: {},
}
